import { useCallback } from 'react';
import type { Locale } from './locales';
import { type TranslationValues, translate } from './translate';
import { useLocale } from './use-locale';

type Translation = {
  readonly locale: Locale;
  readonly t: (key: string, values?: TranslationValues) => string;
  readonly tn: (count: number, one: string, other: string, values?: TranslationValues) => string;
};

/** Re-renders the component when the locale changes (docs/conventions/i18n.md). */
export function useTranslation(): Translation {
  const locale = useLocale();
  const t = useCallback(
    (key: string, values?: TranslationValues) => translate(locale, key, values),
    [locale],
  );
  const tn = useCallback(
    (count: number, one: string, other: string, values?: TranslationValues) =>
      translate(locale, count === 1 ? one : other, { count, ...values }),
    [locale],
  );
  return { locale, t, tn };
}
